import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import the centralized config

const D01BarChartViz03 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by job classification (demographic_category_03 in the new JSON)
    const jobClassificationCounts = filteredData.reduce((acc, item) => {
      const jobClassification = item.demographic_category_03; // Use demographic_category_03 for Job Classification
      if (!acc[jobClassification]) {
        acc[jobClassification] = 0;
      }
      acc[jobClassification]++;
      return acc;
    }, {});

    // Sort job classification names alphabetically
    const jobClassificationNames = Object.keys(jobClassificationCounts).sort(
      (a, b) => a.localeCompare(b)
    );
    const chartData = jobClassificationNames.map(
      (jobClassification) => jobClassificationCounts[jobClassification]
    );

    // Update state
    setCategories(jobClassificationNames);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25;
    const minBars = 10;
    const chartHeight = Math.max(
      barHeight * jobClassificationNames.length,
      barHeight * minBars
    );
    // Chart options
    const optionsViz03 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight, // Dynamically set the chart height
        width: "100%", // Fill the container's width
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          distributed: false,
          barHeight: "22.5px",
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 20,
        style: {
          colors: ["#000"], // Set data labels to black
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: jobClassificationNames,
      },
    };

    // Render the chart
    const viz03 = new ApexCharts(
      document.querySelector("#viz-03"),
      optionsViz03
    );
    viz03.render();

    // Cleanup chart on component unmount
    return () => {
      viz03.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", height: "100%", overflowY: "auto" }}>
      {" "}
      {/* Enable vertical scrolling */}
      <div id="viz-03"></div>
    </div>
  );
};

export default D01BarChartViz03;
